import { NgModule } from '@angular/core';
import { GenesysCloudCommonConversationsModule } from './common/genesys-cloud-common-conversations.module';
import { GenesysCloudMessageConversationsModule } from './messages/genesys-cloud-message-conversations.module';
import { GenesysCloudEmailConversationsModule } from './emails/genesys-cloud-email-conversations.module';
import { GenesysCloudWebDeploymentsModule } from './web-deployments/genesys-cloud-web-deployments.module';

@NgModule({
  imports: [
    GenesysCloudCommonConversationsModule,
    GenesysCloudMessageConversationsModule,
    GenesysCloudEmailConversationsModule,
    GenesysCloudWebDeploymentsModule
  ]
})
export class GenesysCloudConversationsModule {}
